'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var R = require('ramda');

var timers = {};
/**
 * Middleware for debouncing redux actions
 * @param {Array} debounceCheckers - Each function in the array checks if action needs to be debounced
 * @returns {Function} Redux middleware
 * @example
 * applyMiddleware(
 *   debounceMiddleware([
 *     (action) => {key: 'unique-key', time:500}, // Will debounce
 *     (action) => undefined // Will not debounce
 *   ])
 * )
 */

function debounceMiddleware() {
  var debounceCheckers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (store) {
    return function (next) {
      return function (action) {
        var state = store.getState();
        var debounce = R.reduceWhile(R.isNil, function (shouldDebounce, checker) {
          return checker(action, state);
        }, undefined, debounceCheckers);

        if (!debounce) {
          return next(action);
        }

        if (typeof debounce.key !== 'string') {
          // eslint-disable-next-line no-console
          console.error('Expected `key` to be a string. Action will be dispatched immediately.');
          return next(action);
        }

        if (typeof debounce.time !== 'number') {
          // eslint-disable-next-line no-console
          console.error('Expected `time` to be a number. Action will be dispatched immediately.');
          return next(action);
        }

        if (timers[debounce.key]) {
          clearTimeout(timers[debounce.key]);
        }

        timers[debounce.key] = setTimeout(function () {
          return next(action);
        }, debounce.time);
      };
    };
  };
}

exports.debounceMiddleware = debounceMiddleware;
//# sourceMappingURL=debounce-middleware.js.map
